// Auth Store
import { getField } from 'vuex-map-fields'

const state = {
  auth_status: {},
  pendingAuth: false,
  isInit: true,
}

const getters = {
  getField,
}

const actions = {
  getAuthStatus({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.getItem('auth.is_authenticated').then(({ data }) => {
        commit('SET_AUTH_STATUS', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
}

const mutations = {
  SET_AUTH_STATUS: (state, payload) => {
    state.auth_status = payload
    state.isInit = false
  },
  SET_PENDING: state => {
    state.pendingAuth = !state.pendingAuth
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
